const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for adding and updating multiple users at a time
 * @argument {Application} Application defines the Application service
 * @argument {$q} $q defines the $q service
 * @argument {Users} Users defines the Users resource
 */
app.factory('BulkUsers', ['Application', 'Authorization', 'Users', '$q', function (Application, Authorization, Users, $q) {

  var bulkUpdate = function(users) {
    var deferred = $q.defer();

    var promises = [];
    for (var i = 0; i < users.length; i++) {
      promises.push(Users.update({subresource: users[i]._id}, users[i]).$promise);
    }

    $q.all(promises)
    .then(function(users) {
      deferred.resolve(users);
    }).catch(function(err) {
      deferred.reject(err);
    });

    return deferred.promise;
  }

  return {
    bulkUpdate: bulkUpdate
  }
}]);
